// extracted by mini-css-extract-plugin
export default {"container":"_6KC8Z"};